import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const PortalProvider = ({ children, containerId }) => {
	let containerElement = document.getElementById(containerId);
	if (!containerElement) {
		containerElement = document.createElement('div');
		containerElement.setAttribute('id', containerId);
		document.body.appendChild(containerElement);
	}
	return ReactDOM.createPortal(children, containerElement);
};

PortalProvider.propTypes = {
	children: PropTypes.node.isRequired,
	containerId: PropTypes.string.isRequired,
};

export default PortalProvider;
